// BaseTypeAccessService.js

import { doc, onSnapshot } from 'firebase/firestore';
import { collections, db, functions, httpsCallable } from 'firebaseConfig';
import { defaultTypeAccess, normalizeTypeAccess } from 'security/typeAccess';
import { buildTenantCallableFields } from 'utilities/basePersistence';

const callable = (name) => httpsCallable(functions, name);

function memberTypePolicyDocument(baseKey) {
  return doc(db, collections.bases, baseKey, 'roleTypePolicies', 'member');
}

export function subscribeToMemberTypeAccess(baseKey, callback, onError) {
  const normalizedBaseKey = String(baseKey || '').trim();
  if (!normalizedBaseKey || typeof callback !== 'function') {
    return () => {};
  }

  return onSnapshot(
    memberTypePolicyDocument(normalizedBaseKey),
    (snapshot) => {
      if (!snapshot.exists()) {
        callback(defaultTypeAccess());
        return;
      }
      callback(normalizeTypeAccess(snapshot.data()?.typeAccess));
    },
    (error) => {
      if (typeof onError === 'function') onError(error);
      else console.error('[BaseTypeAccessService] subscribeToMemberTypeAccess error:', error);
      callback(defaultTypeAccess());
    }
  );
}

export async function setBaseMemberTypeAccess(baseKey, typeAccess) {
  const fn = callable('setBaseMemberTypeAccess');
  const result = await fn({
    ...buildTenantCallableFields(baseKey),
    typeAccess: normalizeTypeAccess(typeAccess),
  });
  return result?.data || null;
}

export async function updateCustomRoleTypeAccess(baseKey, roleId, typeAccess) {
  const fn = callable('updateBaseRole');
  const result = await fn({
    ...buildTenantCallableFields(baseKey),
    roleId,
    typeAccess: normalizeTypeAccess(typeAccess),
  });
  return result?.data || null;
}
